/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ApiMode } from '@vsolv/core/multi-tenant/domain';
import { isVectorSolvRequest } from '@vsolv/dev-kit/ngx';
import { Auth } from 'firebase/auth';
import { Observable, switchMap } from 'rxjs';
import { FIREBASE_AUTH } from '../tokens';
import { idToken$ } from '../utils/firebase-auth.rx';

export const API_MODE = new InjectionToken<ApiMode>('API_MODE');

/** This interceptor attempts to add the bearer token to request headers*/
@Injectable()
export class FirebaseInterceptor implements HttpInterceptor {
  constructor(@Inject(FIREBASE_AUTH) private auth: Auth) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isVectorSolvRequest(req)) {
      return next.handle(req);
    }
    return idToken$(this.auth).pipe(switchMap(token => next.handle(this.handleRequest(req, token))));
  }

  /** Interceptor attempts to retrieve the tenant id from local storage and add it to the outgoing vectorsolv api request's headers  */
  private handleRequest(request: HttpRequest<any>, idToken: string | null) {
    const outgoing = request.clone({ setHeaders: { Authorization: `Bearer ${idToken}` } });
    return outgoing;
  }
}
